import { render } from "./listPackage.vue?vue&type=template&id=82ec1544&scoped=true"
import script from "./listPackage.vue?vue&type=script&lang=js"
export * from "./listPackage.vue?vue&type=script&lang=js"

import "./listPackage.vue?vue&type=style&index=0&id=82ec1544&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82ec1544"]])

export default __exports__